// -----------------------
// <auto-generated>
// Generated using the script normalizrSchemaGenerator.js
// </auto-generated>
// -----------------------
import {
    Address,
    BillingAddressDetails,
    BillingBankDetailDetails,
    BillingOrderNumberDetails,
    ChangeFinancialConditionDetails,
    ChangeHeadOfficeAddressDetails,
    ContractBilling,
    ContractInformation,
    ContractTransferDetails,
    DocumentAccountExtractDetails,
    DocumentContractRelatedDetails,
    DocumentCopyOfContractualElementDetails,
    DocumentEquipmentRelatedDetails,
    EndOfContractDenialOfContractRenewalDetails,
    EndOfContractEarlyRedemptionDetails,
    EndOfContractExerciseOfPurchaseOptionDetails,
    EndOfContractReturnOfEquipmentDetails,
    EndOfContractTerminationOfContractDetails,
    FinancialRequestDetailed,
    FinancialRequestSummary,
    Funding,
    LoggedUser,
    Person,
    SaveFinancialResponse,
    Status,
    ThirdAddress,
} from './FranfinanceApiClient';

export enum ObjectsWithoutIdPropertyEnum {
    Address,
    BillingAddressDetails,
    BillingBankDetailDetails,
    BillingOrderNumberDetails,
    ChangeFinancialConditionDetails,
    ChangeHeadOfficeAddressDetails,
    ContractBilling,
    ContractInformation,
    ContractTransferDetails,
    DocumentAccountExtractDetails,
    DocumentContractRelatedDetails,
    DocumentCopyOfContractualElementDetails,
    DocumentEquipmentRelatedDetails,
    EndOfContractDenialOfContractRenewalDetails,
    EndOfContractEarlyRedemptionDetails,
    EndOfContractExerciseOfPurchaseOptionDetails,
    EndOfContractReturnOfEquipmentDetails,
    EndOfContractTerminationOfContractDetails,
    FinancialRequestDetailed,
    FinancialRequestSummary,
    Funding,
    LoggedUser,
    Person,
    SaveFinancialResponse,
    Status,
    ThirdAddress,
}

export type ObjectsWithoutIdProperty =
    Address
    | BillingAddressDetails
    | BillingBankDetailDetails
    | BillingOrderNumberDetails
    | ChangeFinancialConditionDetails
    | ChangeHeadOfficeAddressDetails
    | ContractBilling
    | ContractInformation
    | ContractTransferDetails
    | DocumentAccountExtractDetails
    | DocumentContractRelatedDetails
    | DocumentCopyOfContractualElementDetails
    | DocumentEquipmentRelatedDetails
    | EndOfContractDenialOfContractRenewalDetails
    | EndOfContractEarlyRedemptionDetails
    | EndOfContractExerciseOfPurchaseOptionDetails
    | EndOfContractReturnOfEquipmentDetails
    | EndOfContractTerminationOfContractDetails
    | FinancialRequestDetailed
    | FinancialRequestSummary
    | Funding
    | LoggedUser
    | Person
    | SaveFinancialResponse
    | Status
    | ThirdAddress;
